import {QUERY_PARAMS} from '../common/queryParams.js'

const {SEARCH: SHARED_SEARCH_QUERY_PARAMS, SORT: SHARED_SEARCH_SORT_QUERY_PARAMS} = QUERY_PARAMS

// Define only the queryParams that are different from the common ones
export const SEARCH = {...SHARED_SEARCH_QUERY_PARAMS}
export const SORT = {...SHARED_SEARCH_SORT_QUERY_PARAMS}
